import { render, staticRenderFns } from "./QuickBrandForm.vue?vue&type=template&id=594dbbf8&"
import script from "./QuickBrandForm.vue?vue&type=script&lang=js&"
export * from "./QuickBrandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports